/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { RechtsgrundEntryMeta } from './rechtsgrundEntryMeta';
import { StandardrechtBeteiligungMasterId } from './standardrechtBeteiligungMasterId';
import { GrundstueckListEntryMeta } from './grundstueckListEntryMeta';
import { LastRechtGruppeIdMeta } from './lastRechtGruppeIdMeta';


export interface LastRechtGrundstueckEntryMeta { 
    rechtsgruende?: Array<RechtsgrundEntryMeta>;
    mRechtsgruende?: FieldMetaData;
    lastRechtGruppeId?: LastRechtGruppeIdMeta;
    mLastRechtGruppeId?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    grundstueck?: GrundstueckListEntryMeta;
    mGrundstueck?: FieldMetaData;
    belastungArt?: LastRechtGrundstueckEntryMeta.BelastungArtEnum;
    mBelastungArt?: FieldMetaData;
    standardrechtBeteiligungMasterId?: StandardrechtBeteiligungMasterId;
    mStandardrechtBeteiligungMasterId?: FieldMetaData;
}
export namespace LastRechtGrundstueckEntryMeta {
    export type BelastungArtEnum = 'BELASTET' | 'BERECHTIGT' | 'BELASTET_BERECHTIGT' | 'DOMINANTINDET';
    export const BelastungArtEnum = {
        BELASTET: 'BELASTET' as BelastungArtEnum,
        BERECHTIGT: 'BERECHTIGT' as BelastungArtEnum,
        BELASTET_BERECHTIGT: 'BELASTET_BERECHTIGT' as BelastungArtEnum,
        DOMINANTINDET: 'DOMINANTINDET' as BelastungArtEnum
    };
}


